import React, { lazy } from 'react';
import { PreviewView } from '@shared/ui/home/PreviewView';
import { Versioned } from '@shared/ui/uiVersion';
import { MainLayout } from '../layouts';
import { usePageDocumentTitle } from '../hooks/useDocumentTitle';

// Loaded only when shown, so its global CSS never reaches the new look
const ClassicPreviewPage = lazy(() => import('./classic/PreviewPage'));

/** The signed-out preview of past days: the shared view in this app's frame (ADR-0008), or classic. */
const PreviewPage: React.FC = () => {
  usePageDocumentTitle('Free Horse Racing Tips Preview');
  return (
    <Versioned classic={<ClassicPreviewPage />}>
      <MainLayout>
        <PreviewView />
      </MainLayout>
    </Versioned>
  );
};

export default PreviewPage;
